/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityStatsSurfaceCategory
 */
export interface MonitEntityStatsSurfaceCategory {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityStatsSurfaceCategory
     */
    key?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityStatsSurfaceCategory
     */
    value?: number;
}

/**
 * Check if a given object implements the MonitEntityStatsSurfaceCategory interface.
 */
export function instanceOfMonitEntityStatsSurfaceCategory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityStatsSurfaceCategoryFromJSON(json: any): MonitEntityStatsSurfaceCategory {
    return MonitEntityStatsSurfaceCategoryFromJSONTyped(json, false);
}

export function MonitEntityStatsSurfaceCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityStatsSurfaceCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function MonitEntityStatsSurfaceCategoryToJSON(value?: MonitEntityStatsSurfaceCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'value': value.value,
    };
}

